import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import MenuItem from 'components/Menu/MenuItem';
import HelpOutlineRoundedIcon from '@material-ui/icons/HelpOutlineRounded';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import PersonOutlineIcon from '@material-ui/icons/PersonOutline';
import CreditCardIcon from '@material-ui/icons/CreditCard';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import ModeCommentOutlinedIcon from '@material-ui/icons/ModeCommentOutlined';
import { openNewTab } from 'utils/misc';
import { HELP_CENTER, BILLING } from 'constants/routing';
import { SUPPORT_EMAIL } from 'constants/config';
import { Can } from 'utils/permissions';


const styles = () => ({
  menuIcon: {
    width: '1.2rem',
    marginRight: '0.5rem',
  },
});

const ProfileMenuItems = (props) => {
  const { classes } = props;
  const handleHelp = () => {
    openNewTab(HELP_CENTER);
  };

  const handleBilling = () => {
    openNewTab(BILLING);
  };

  const handleSupportMail = () => {
    window.location = `mailto:${SUPPORT_EMAIL}`;
  };

  return (<>
    <MenuItem onClick={handleHelp}>
      <HelpOutlineRoundedIcon className={classes.menuIcon} />
      Go to Help Center
    </MenuItem>
    <MenuItem onClick={handleSupportMail}>
      <MailOutlineIcon className={classes.menuIcon} />
      {SUPPORT_EMAIL}
    </MenuItem>
    <MenuItem onClick={props.handleChatWithUs}>
      <ModeCommentOutlinedIcon className={classes.menuIcon} />
      Chat with us
    </MenuItem>
    <MenuItem onClick={props.handleMyAccount}>
      <PersonOutlineIcon className={classes.menuIcon} />
      My Account
    </MenuItem>
    <Can I="see" a="Billing">
      <MenuItem onClick={handleBilling}>
        <CreditCardIcon className={classes.menuIcon} />
        Subscription & Billing
      </MenuItem>
    </Can>
    <hr />
    <MenuItem onClick={props.handleLogout}>
      <ExitToAppIcon className={classes.menuIcon} />
      Log out
    </MenuItem>
  </>);
};

export default withStyles(styles)(ProfileMenuItems);
